<div class="info-modal">
  <div class="info-modal-wrapper">
    <div class="info-modal-wrapper-block">
      <div class="info-modal-wrapper-block-text">
        <div class="info-modal-wrapper-block-text-title">
          {{ data?.title | translate }}
        </div>
        <div class="info-modal-wrapper-block-text-inscription">
          {{ data?.description | translate }}
        </div>
      </div>
      <div class="info-modal-wrapper-block-btns">
        <button
          class="info-modal-wrapper-block-btns-confirm"
          mat-raised-button
          color="primary"
          [mat-dialog-close]="true">
          {{ 'confirm' | translate }}
        </button>
        @if (data?.cancel) {
          <button
            class="info-modal-wrapper-block-btns-cancel"
            mat-raised-button
            [mat-dialog-close]="false">
            {{ 'cancel' | translate }}
          </button>
        }
      </div>
    </div>
    <app-lsap-icon name="confusedBon" class="info-modal-bon"></app-lsap-icon>
    @if (data?.crossIcon) {
      <mat-icon class="info-modal-wrapper-icon" [mat-dialog-close]="false">clear</mat-icon>
    }
  </div>
</div>
